var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg24Support1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 47.1492H43.1C41.1 47.1492 39.2 47.9242 37.8 49.3242L33.525 53.5495C31.575 55.4745 28.4 55.4745 26.45 53.5495L22.175 49.3242C20.775 47.9242 18.85 47.1492 16.875 47.1492H15C10.85 47.1492 7.5 43.8245 7.5 39.7245V12.4493C7.5 8.34934 10.85 5.02441 15 5.02441H45C49.15 5.02441 52.5 8.34934 52.5 12.4493V39.7245C52.5 43.7995 49.15 47.1492 45 47.1492Z",
    stroke: "#778D50",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5 22.8995C17.5 20.5745 19.4 18.6743 21.725 18.6743C24.05 18.6743 25.95 20.5745 25.95 22.8995C25.95 27.5995 19.275 28.0995 17.8 32.5745C17.5 33.4995 18.275 34.4245 19.25 34.4245H25.95",
    stroke: "#778D50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.0995 34.3997V20.1248C40.0995 19.4748 39.6745 18.8996 39.0495 18.7246C38.4245 18.5496 37.7495 18.7996 37.3995 19.3496C35.5995 22.2496 33.6495 25.5497 31.9495 28.4497C31.6745 28.9247 31.6745 29.5497 31.9495 30.0247C32.2245 30.4997 32.7495 30.7995 33.3245 30.7995H42.4995",
    stroke: "#778D50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Support1);
export default __webpack_public_path__ + "static/media/24-support1.a88db8a934926da6a9b5530f19d53be8.svg";
export { ForwardRef as ReactComponent };